var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExportTool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button/export/default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.7818571,8.77532468 L9.71428571,8.77532468 L9.71428571,5.41818182 C9.71428571,5.0488961 9.41214286,4.74675325 9.04285714,4.74675325 L6.35714286,4.74675325 C5.98785714,4.74675325 5.68571429,5.0488961 5.68571429,5.41818182 L5.68571429,8.77532468 L4.61814286,8.77532468 C4.02057143,8.77532468 3.71842857,9.50046753 4.14142857,9.92346753 L7.22328571,13.0053247 C7.48514286,13.2671818 7.90814286,13.2671818 8.17,13.0053247 L11.2518571,9.92346753 C11.6748571,9.50046753 11.3794286,8.77532468 10.7818571,8.77532468 Z M3,2.67142857 C3,3.04071429 3.30214286,3.34285714 3.67142857,3.34285714 L11.7285714,3.34285714 C12.0978571,3.34285714 12.4,3.04071429 12.4,2.67142857 C12.4,2.30214286 12.0978571,2 11.7285714,2 L3.67142857,2 C3.30214286,2 3,2.30214286 3,2.67142857 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button/export/default",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/action/export"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button-placer",
    fill: "#FFFFFF",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero",
    transform: "translate(7.700000, 7.600859) scale(1, -1) translate(-7.700000, -7.600859) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Neutral-Fill",
    mask: "url(#mask-2)",
    fill: "#005082"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Fill",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExportTool);
export default __webpack_public_path__ + "static/media/icon_export_tool.1ca361bbca29c97f0d441ef67d2152ef.svg";
export { ForwardRef as ReactComponent };